import { Button, Flex } from '@chakra-ui/react';
import { FC } from 'react';

export const SubmitButton: FC<{ isLoading?: boolean; title?: string }> = ({ title, isLoading }) => {
  return (
    <Button
      borderRadius='0.25rem'
      fontSize='16px'
      padding='1.25rem 1.5rem'
      type='submit'
      isLoading={isLoading}
      width='100%'
      background='#113FE3'
      _hover={{ backgroundColor: '#0f37c9' }}
      _disabled={{ background: '#5e7ded', _hover: { background: '#5e7ded' } }}
      color='white'
      cursor='pointer'
      boxShadow='0px 16px 54px rgba(70, 83, 246, 0.16)'
      border='none'
    >
      <Flex alignItems='center' gap='0.75rem' lineHeight='100%'>
        {title ? title : 'Submit Secure Payment'}
        <svg width='16' height='16' viewBox='0 0 20 20' fill='white' xmlns='http://www.w3.org/2000/svg'>
          <g clipPath='url(#clip0_180_2859)'>
            <path d='M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z' />
          </g>
          <defs>
            <clipPath id='clip0_180_2859'>
              <rect width='20' height='20' fill='white' />
            </clipPath>
          </defs>
        </svg>
      </Flex>
    </Button>
  );
};
